export function getFirstFocusableElement(parent) {
    const $elements = parent.querySelectorAll('a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"]')
    if ($elements[0]) {
        $elements[0].focus();
    }
}